import Vue from 'vue';
import Vuex from 'vuex';
import { getToken, removeToken } from './utils/auth';
import request from './utils/request';

Vue.use(Vuex);

const preUserInfo = {
  name: '',
  sex: '',
  avatar: '',
  birthday: '',
  introduction: '',
  mobile: '',
  userId: 0,
  follow: 0,
  followUserIds: [],
  fans: 0,
  fansUserIds: [],
  like: 0,
  likeUserIds: [],
  album: [],
  favorite: [],
  study: []
};

export default new Vuex.Store({
  state: {
    userInfo: { ...preUserInfo },
    system: {
      category: [],
      material: [],
      type: [],
      diamond: [],
      brand: [],
      hotKey: []
    },
    SearchHistory: [],
    previewShow: false
  },

  getters: {
    token: state => {
      if (state.userInfo) {
        return getToken();
      }
    },
    // userInfo: state => state.userInfo,
  },

  mutations: {
    // 设置previewShow
    setPreviewShow: (state, data) => {
      state.previewShow = data
    },
    // 储存搜索历史
    VmSearchHistory(state, newTick) {
      state.SearchHistory = newTick
    },
    // 修改对应的用户信息
    VmUserInfo(state, category) {
      state.userInfo[category.category] = category.msg
    },
    USER_INFO: (state, payload) => {
      for (let key in payload) {
        state.userInfo[key] = payload[key];
      }
    },

    SYSTEM: (state, payload) => {
      state.system = payload;
    }
  },

  actions: {
    ChangePreviewShow(commit, data) {
      commit.commit('setPreviewShow', data)
    },
    ChangeVmUserInfo(commit, category) {
      commit.commit('VmUserInfo', category)
    },
    ChangeVmSearch(commit, newTick) {
      commit.commit('VmSearchHistory', newTick)
    },
    // 获取用户信息
    RefreshUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        request.post('/user_more/info').then(data => {

          //fixme:OSS未支持https,兼容处理
          data.avatar = data.avatar.replace(/(https?:)?\/\//, 'http://')
          // data.album.forEach((item, i)=>{
          //   data.album[i].url = item.url.replace(/(https?:)?\/\//, 'http://')
          // })

          commit('USER_INFO', data);
          resolve(data);
        }).catch(error => {
          reject(error);
        });
      });
    },

    GetSystem({ commit }) {
      return new Promise((resolve, reject) => {
        request.get('/config').then(data => {
          commit('SYSTEM', data);
          resolve(data);
        }).catch(error => {
          reject(error);
        });
      });
    },

    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        // 清除token等操作
        commit('USER_INFO', { ...preUserInfo });
        removeToken();
        resolve();
      });
    }
  }
})
